import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ELearningService} from '../../../../core/services/e-learning.service';

@Component({
  selector: 'event-detail-modal',
  templateUrl: './recommendation-detail.modal.html',
  styleUrls: ['./recommendation-detail.modal.scss'],
  standalone: false
})

export class RecommendationDetailModal implements OnInit {
  event: any;
  elearning: any;
  constructor(public dialogRef: MatDialogRef<RecommendationDetailModal>,
              @Inject(MAT_DIALOG_DATA) private data: any, private elService: ELearningService) {
    if (this.data) {
      if (this.data.event) {
        this.event = this.data.event;
      }
      if (this.data.elearning) {
        if (this?.data?.elearning?.elearning?.questions) {
          this.data.elearning.elearning.questions = this.elService.atobUtf8(this.data.elearning.elearning.questions);
        }
        this.elearning = this.data.elearning;
      }
    }
  }

  ngOnInit() {

  }

  subscribe() {
    this.dialogRef.close(true)
  }
}
